export const FREE_PARKING_AMENITY_ID = '9d80786b-1f85-47a3-b710-1b8fb0d77df9'
